import {z} from 'zod'

import {contactSchema} from '../common/schema'

export const orderPlacerSchema = z.object({
  orderPlacer: contactSchema.optional()
})
